export default {

    // 类型
    type:{
        type:String,
        default:''
    }

}